// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"118":"e2db984a","453":"eeea94ac","454":"c4c53848","702":"5ab88523"}[chunkId] + ".chunk.js";
};